import { render, staticRenderFns } from "./toolBarBtn.vue?vue&type=template&id=b1a95846&scoped=true"
import script from "./toolBarBtn.vue?vue&type=script&lang=js"
export * from "./toolBarBtn.vue?vue&type=script&lang=js"
import style0 from "./toolBarBtn.vue?vue&type=style&index=0&id=b1a95846&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a95846",
  null
  
)

export default component.exports